import styled from 'styled-components'
import { device } from '../../../styles/GlobalVariables'
import { PlayerDiv } from '../Player/Player.style'
import Link from '../../../components/Link/Link'
import { mediaCdn } from '../../../components/Player/Helpers'

interface StyledProgramItemProps {
  playerImage: string
}

interface LogoProps {
  logoImage: string
}

export const PlayerBackgroundImageGradient = styled.div`
  background: url(${mediaCdn}q_auto:best/v1709131978/uploads/2024/903953721.webp);
  height: 683px;
  position: absolute;
  width: 100%;
  z-index: 1;
  left: 0;
  top: -60px;
`

export const PlayerBackground = styled.div<StyledProgramItemProps>`
  display: flex;
  flex-direction: column;

  ${device.small} {
    &::before {
      content: '';
      position: absolute;
      top: -50px;
      left: 0;
      width: 88%;
      height: 668px;

      background: ${({ playerImage }) => `url(${playerImage})`};
      background-position: center;
      filter: blur(2px);
      background-size: cover;
      background-repeat: no-repeat;
      z-index: 1;
    }
  }
`
const playerWidth = {
  desktop: '49.9vw',
  mobile: '100%',
}

export const BannerWrapper = styled.div`
  display: flex;
  width: auto;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  background: #1e1e1e;
  position: relative;
  bottom: 5px;

  ${device.medium} {
    display: flex;
    width: auto;
    height: auto;
    //padding: 0 475px;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background: transparent;
    margin-bottom: -20px;
  }
`

export const TaboolaColumn = styled.div`
  display: none;
  flex-direction: column;
  align-items: end;
  gap: 30.5px;
  color: #fff;
  margin-top: 10px;
  flex-shrink: 0;
  align-self: flex-start;
  width: 250px;

  ${device.medium} {
    display: inline-flex;
    width: 90%;
  }
`
export const LeftRailItemLink = styled(Link)`
  text-decoration: none;
  width: 422px;
  margin: 0 auto;
`
export const LeftRailItem = styled.div`
  width: 422px;
  height: 141px;
  margin-bottom: 15px;
  margin-top: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 12px;
  border-bottom: 10px solid transparent; /* Define border width */
  border-image-source: url(https://media3.reshet.tv/image/upload/v1742385545/uploads/2025/904509791.webp);
  border-image-slice: 30; /* Adjust based on the image */
  border-image-repeat: stretch; /* Options: round, repeat, stretch */
`
export const LeftRailItemSeparator = styled.img`
  display: block;
  width: 422px;
  height: 4px;
  margin: 0 auto;
`

export const LeftRailItemImage = styled.img`
  width: 250px;
  height: 141px;
  border-radius: 10px;
`

export const Title = styled.h1`
  margin-top: 20px;
  color: #fff;
  text-align: right;
  text-shadow: 0 4px 60px rgba(255, 255, 255, 0.15);
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 94%;
  letter-spacing: -0.8px;
  margin-right: 5.73vw;
  margin-bottom: 60px;

  ${device.medium} {
    font-size: 40px;
    margin-top: 40px;
  }
`

export const LeftRailItemTitleCreditContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const LeftRailItemTitle = styled.div`
  color: #fff;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  width: 160px;
`

export const LeftRailItemCredit = styled.div`
  color: rgba(255, 255, 255, 0.5);
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  width: 160px;
`

export const DynamicColumnsWrapper = styled.div`
  display: flex;
  grid-template-columns: 1fr;
  flex-direction: column;
  gap: 40px;

  ${device.small} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`

export const PlayerWrapper = styled.div`
  width: 100vw;

  ${device.medium} {
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    width: 70vw;

    ${PlayerDiv} {
      min-height: 100px;
      max-height: 100%;
      max-width: 100%;
      aspect-ratio: 16 / 9;
    }
  }
`

export const VideoBreadCrumb = styled.div`
  ${device.medium} {
    display: flex;
    padding-right: 115px;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 10px;
  }
`

export const VodTitle = styled.div`
  ${device.medium} {
    color: #fff;
    text-align: right;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    justify-content: start;
    align-items: baseline;
    margin-top: unset;
    margin-bottom: unset;
  }

  color: #fff;
  display: flex;
  justify-content: center;
  width: 100vw;
  margin-top: 20px;
  margin-bottom: 16px;
  text-align: right;
  text-shadow: 0 4px 40px rgba(255, 255, 255, 0.25);
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const PlayerBGWrapper = styled.div`
  background: #000;
  position: relative;

  ${device.medium} {
    width: 70dvw;
    //width: 1348px;
    margin-top: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-self: baseline;
    align-items: center;
    height: 635px;

    .playkit-player
      .playkit-seek-bar.playkit-live
      .playkit-progress-bar
      .playkit-progress {
      background: #fff;
    }
  }
`

export const LivePlayerImage = styled.div`
  align-self: start;
  margin-top: 1.563rem;
  margin-bottom: 0.5rem;
  width: ${playerWidth.desktop};
  height: calc(${playerWidth.desktop} * 9 / 16);
  position: relative;
  z-index: 1;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('${props => props.theme.background}');

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${playerWidth.mobile};
    height: calc(${playerWidth.mobile} * 16 / 9);
    margin-top: 4.5vw;
    margin-bottom: 35px;
  }
`

export const LogoLivePlayer = styled.img<LogoProps>`
  filter: blur(0.7);
  display: block;
  height: 17px;
  content: ${({ logoImage }) => `url(${logoImage})`};
  @media only screen and (max-width: 768px) {
    display: none;
  }
`
export const PlayerInfo = styled.div`
  position: relative;
  z-index: 1;
  display: none;
  justify-content: space-between;
  margin: auto;
  margin-top: 13px;

  max-width: ${playerWidth.mobile};

  ${device.small} {
    display: flex;
    max-width: ${playerWidth.desktop};
    width: 100%;
  }
`

export const LiveLogo = styled.div`
  display: flex;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.84px;
  color: #fff;
  white-space: nowrap;
  line-height: 0.68;

  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`

export const LiveLogoLineLine = styled.div`
  background-color: #fff;
  width: 3px;
  height: 100%;
  margin-left: 7px;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`
export const LivePlayerTitle = styled.div`
  display: flex;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  margin-top: 3px;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.84px;
  color: #fff;
  white-space: nowrap;
  @media only screen and (min-width: 768px) {
    display: none;
  }
`
export const LiveLogoWrap = styled.div`
  display: flex;
  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
  }
`
